<template>
  <div>
    <div class="qrWrap">
      <p class="title">完成实名认证</p>
      <vue-qr class="qrStyle" :text="url" style="display: block;" :margin="0" />
      <div class="bottomContent">
        <p class="text1">请使用手机扫码进行实名认证</p>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol */
import VueQr from 'vue-qr'
export default {
  name: 'NoOpen',
  components: {
    VueQr
  },
  data() {
    return {
      routerPath: '',
      tel: localStorage.getItem('myPhone'),
      baseUrl: window.g.APP_PATH_mobile,
      fundUrl: localStorage.getItem('qrContent'),
      url: ''
    }
  },
  mounted() {
    this.findUserStatusProcess()
  },
  methods: {
    // 得到秘钥 --- 开户
    getSessionKey(type) {
      protocol.param_getSessionKeyOpen.url = `/base-desk-query/userSession/getSessionKey?type=${type}`
      http
        .getRes(protocol.param_getSessionKeyOpen)
        .then(response => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            this.url = `${this.baseUrl}key=${value}&tel=${this.tel}`
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
          // setTimeout(() => {
          //   this.queryQuantity()
          // }, 1000)
        })
    },
    // 查询用户状态 isAudit  pOro
    findUserStatusProcess() {
      http.postFront(protocol.param_findUserStatusProcess).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            // 代表已开户 true   false代表未开户
            // this.isOpen = true
            if (!value.audit) {
              if (value.poro == 'O') {
                switch (value.authentication.status) {
                  case 'license': // 已上传营业执照
                    this.routerPath = 15
                    this.getSessionKey(15)
                    break
                  case 'certificate': // 已上传身份证
                    this.routerPath = 16
                    this.getSessionKey(16)
                    break
                  case 'information': // 已完善资料
                    // auditStatus=5 signatureQuantity=5  进人工审核
                    if (
                      value.authentication.auditStatus === 5 &&
                  value.authentication.signatureQuantity === 5
                    ) {
                      // 人工审核电子签名
                      this.routerPath = 17
                      this.getSessionKey(17)
                    } else {
                      this.routerPath = 18
                      this.getSessionKey(18)
                    }
                    break
                  case 'signature': // 已电子签名
                    this.routerPath = 19
                    this.getSessionKey(19)
                    break
                  case 'agreement': // 已签署协议
                    this.routerPath = 20
                    this.getSessionKey(20)
                    break
                  case 'success': // 已实名认证
                    break

                  default:
                    break
                }
              } else if (value.poro == 'P') {
                switch (value.authentication.status) {
                  case 'answer': // 已答题
                    this.routerPath = 7
                    this.getSessionKey(7)
                    break
                  case 'employed': // 已上传从业证明
                    this.routerPath = 8
                    this.getSessionKey(8)
                    break
                  case 'certificate': // 已上传身份证
                    this.routerPath = 9
                    this.getSessionKey(9)
                    break
                  case 'information': // 已完善资料
                  // auditStatus=5 signatureQuantity=5  进人工审核
                    if (
                      value.authentication.auditStatus === 5 &&
                value.authentication.signatureQuantity === 5
                    ) {
                      this.routerPath = 10
                      this.getSessionKey(10)
                    // 人工审核电子签名
                    } else {
                      this.routerPath = 11
                      this.getSessionKey(11)
                    }
                    break
                  case 'signature': // 已电子签名
                    this.routerPath = 12
                    this.getSessionKey(12)
                    break
                  case 'agreement': // 已签署协议
                    if (value.authentication.auditStatus === 6) {
                    // Toast('视频人工审核中')
                    // 跳转到"人工审核"
                      this.routerPath = 13
                      this.getSessionKey(13)
                    } else {
                      this.routerPath = 14
                      this.getSessionKey(14)
                    }
                    break
                  default:
                    break
                }
              } else if (value.poro == 'N') {
                this.routerPath = 21
                this.getSessionKey(21)
              }
            } else {
              this.$router.push('/quotationList')
            }
          } else {
            this.routerPath = 21
            this.getSessionKey(21)
          }
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.qrWrap {
  width: 1006px;
  background-color: #f1f1f1;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 80px;
  .title {
    font-family: Source Han Sans SC;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
    padding-top: 109px;
    padding-bottom: 49px;
    text-align: center;
  }
  .qrStyle {
    width: 270px;
    height: 270px;
    margin: 0 auto;
  }
  .bottomContent {
    padding: 38px 0 199px;
    .text1 {
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      text-align: center;
    }
  }
}
</style>
